import axios from "utils/axios";
import { stringify } from "query-string";

export const getKpiTimelines = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/kpi/timelines/pagination?${query}`);
};

export const getKpiTimelineUsers = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/kpi/timelines/users?${query}`);
};

export const getKpiTimelineForms = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/kpi/timelines/forms?${query}`);
};

export const getKpiTimeline = (data) => {
  return axios.get(`/hr/kpi/timelines/${data?.id}`);
};

export const addKpiTimelinePeriod = (data) => {
  return axios.post(`/hr/kpi/timelines/period`, data);
};

export const addKpiTimelineUsers = (data) => {
  return axios.post(`/hr/kpi/timelines/${data?.id}/users`, data);
};

export const addKpiTimelineEvaluators = (data) => {
  return axios.post(`/hr/kpi/timelines/${data?.id}/evaluators`, data);
};

export const editKpiTimelinePeriod = (data) => {
  return axios.put(`/hr/kpi/timelines/${data?.id}/period`, data);
};

export const editKpiTimelineUsers = (data) => {
  return axios.put(`/hr/kpi/timelines/${data?.id}/users`, data);
};

export const editKpiTimelineEvaluators = (data) => {
  return axios.put(`/hr/kpi/timelines/${data?.id}/evaluators`, data);
};

export const deleteKpiTimeline = (id) => {
  return axios.delete(`/hr/kpi/timelines/${id}`);
};

export const activateKpiTimeline = (id) => {
  return axios.patch(`/hr/kpi/timelines/${id}/activate`);
};

export const deactivateKpiTimeline = (id) => {
  return axios.patch(`/hr/kpi/timelines/${id}/deactivate`);
};

export const archiveKpiTimeline = (id) => {
  return axios.patch(`/hr/kpi/timelines/${id}/draft`);
};

export const unarchiveKpiTimeline = (id) => {
  return axios.patch(`/hr/kpi/timelines/${id}/publish`);
};
